import Pattern from '../ASSETS/TriominoPattern.svg';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
